module.exports = __webpack_public_path__ + "img/Map_Line_16px_Icon_deactive_dark.33c4c28c.svg";